import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { Grid, Icon, IconButton } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ArtApi from "../api/ArtApi";
import { ReviewStatus } from "../models/IReviewer";

interface ICompletedReviewButtonProps {
    eventId: string,
    dataScience: boolean,
    discard: boolean,
    completedCallback: (arg0: ReviewStatus) => void
}

export const CompletedReviewButton = (props: ICompletedReviewButtonProps) => {
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleComplete = () => {
        setIsLoading(true);
        ArtApi.completeReview(props.eventId, props.dataScience, props.discard)
            .then(result => {
                setIsLoading(false);
                setIsSuccess(result.result);
                if (result.error) {
                    setSnackbarOpen(true);
                    setError(result.error)
                }else{
                if(props.discard){
                    props.completedCallback(ReviewStatus.discard)
                }else{
                    props.completedCallback(ReviewStatus.complete)
                }
            }
                
            }).catch(error => {
                setIsLoading(false);
                setSnackbarOpen(true);
                setError(error.message);
            })
    };


    return (
        <div>
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <SnackbarContent
                    className="errorSnackbar"
                    message={
                        <span id="message-id" className="snackbarMessage">
                            <Icon className="snackbarIcon">error</Icon>
                            Error Occured: {error}
                        </span>
                    }
                    action={[
                        <IconButton
                            key="close"
                            aria-label="close"
                            color="inherit"
                            onClick={() => setSnackbarOpen(false)}
                        >
                            <Icon>close</Icon>
                        </IconButton>
                    ]}
                />
            </Snackbar>
            <Grid container spacing={3}>
                <Grid item>
                    <div className="buttonWrapper">
                        <Button
                            onClick={handleComplete}
                            color={props.discard ? "secondary" : "primary"}
                            variant="contained"
                            disabled={isLoading || isSuccess}
                            className={isSuccess ? "buttonSuccess" : ""}
                        >
                            {props.discard ? "Discard" : props.dataScience ? "Complete & Process" : "Review Complete"}
                        </Button>
                        {isLoading && (
                            <CircularProgress size={24} className="buttonProgress" />
                        )}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}



